import React from 'react';
import {
  Tab,
  Table,
  Item,
} from 'semantic-ui-react';

export const PaneDealer = (props) => {
  const {
    dealer,
    salesperson,
  } = props;

  if (dealer.is_financial) {
    return (
      <Tab.Pane>
        <Item.Group>
          <Item>
            <Item.Content>
              <Item.Header content={dealer.name} />
              <Item.Description>
                <Table celled compact striped color="blue">
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell content="Email" />
                      <Table.Cell content={dealer.email} />
                    </Table.Row>
                    {
                      salesperson
                        ? (
                            <React.Fragment>
                              <Table.Row>
                                <Table.Cell content="Salesperson" />
                                <Table.Cell content={`${salesperson.first_name} ${salesperson.last_name}`} />
                              </Table.Row>
                              <Table.Row>
                                <Table.Cell content="Salesperson Email" />
                                <Table.Cell content={`${salesperson.email}`} />
                              </Table.Row>
                              <Table.Row>
                                <Table.Cell content="Salesperson Phone" />
                                <Table.Cell content={`${salesperson.phone}`} />
                              </Table.Row>
                            </React.Fragment>
                          )
                        : null
                    }
                  </Table.Body>
                </Table>
              </Item.Description>
            </Item.Content>
          </Item>
        </Item.Group>
      </Tab.Pane>
    );
  }

  return (
    <Tab.Pane>
      <Item.Group>
        <Item>
          <Item.Content>
            <Item.Header content={dealer.name} />
            <Item.Description>
              <Table celled compact striped color="blue">
                <Table.Body>
                  <Table.Row>
                    <Table.Cell content="Address" />
                    <Table.Cell
                      content={`${dealer.address_1} ${dealer.city}, ${dealer.state} ${dealer.zip}`}
                    />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell content="Email" />
                    <Table.Cell content={dealer.email} />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell content="Phone" />
                    <Table.Cell content={dealer.phone} />
                  </Table.Row>
                  {
                    salesperson
                      ? (
                          <React.Fragment>
                            <Table.Row>
                              <Table.Cell content="Salesperson" />
                              <Table.Cell content={`${salesperson.first_name} ${salesperson.last_name}`} />
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell content="Salesperson Email" />
                              <Table.Cell content={`${salesperson.email}`} />
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell content="Salesperson Phone" />
                              <Table.Cell content={`${salesperson.phone}`} />
                            </Table.Row>
                          </React.Fragment>
                        )
                      : null
                  }
                </Table.Body>
              </Table>
            </Item.Description>
          </Item.Content>
        </Item>
      </Item.Group>
    </Tab.Pane>
  );
}

